/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GemRouteImport } from './routes/gem'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as ImmersiveRouteImport } from './routes/_immersive'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DemoIndexRouteImport } from './routes/demo/index'
import { Route as DemoTestsRouteImport } from './routes/demo/tests'
import { Route as DemoDesignSystemRouteImport } from './routes/demo/design-system'
import { Route as Demo3dRouteImport } from './routes/demo/3d'
import { Route as DemoTestsIndexRouteImport } from './routes/demo/tests/index'
import { Route as DemoDesignSystemIndexRouteImport } from './routes/demo/design-system/index'
import { Route as Demo3dIndexRouteImport } from './routes/demo/3d/index'
import { Route as DemoTestsComponentSizeTestRouteImport } from './routes/demo/tests/component-size-test'
import { Route as DemoDesignSystemThemingRouteImport } from './routes/demo/design-system/theming'
import { Route as DemoDesignSystemTestsRouteImport } from './routes/demo/design-system/tests'
import { Route as DemoDesignSystemSpecialtyRouteImport } from './routes/demo/design-system/specialty'
import { Route as DemoDesignSystemRadixRouteImport } from './routes/demo/design-system/radix'
import { Route as DemoDesignSystemInteractiveRouteImport } from './routes/demo/design-system/interactive'
import { Route as DemoDesignSystemFoundationsRouteImport } from './routes/demo/design-system/foundations'
import { Route as Demo3dVisualizationRouteImport } from './routes/demo/3d/visualization'
import { Route as Demo3dUxRouteImport } from './routes/demo/3d/ux'
import { Route as Demo3dMemoryRouteImport } from './routes/demo/3d/memory'
import { Route as Demo3dLiveRouteImport } from './routes/demo/3d/live'
import { Route as Demo3dExamplesRouteImport } from './routes/demo/3d/examples'
import { Route as Demo3dDebugRouteImport } from './routes/demo/3d/debug'
import { Route as Demo3dConfigurationRouteImport } from './routes/demo/3d/configuration'
import { Route as DemoDesignSystemThemingIndexRouteImport } from './routes/demo/design-system/theming/index'
import { Route as DemoDesignSystemTestsIndexRouteImport } from './routes/demo/design-system/tests/index'
import { Route as DemoDesignSystemSpecialtyIndexRouteImport } from './routes/demo/design-system/specialty/index'
import { Route as DemoDesignSystemRadixIndexRouteImport } from './routes/demo/design-system/radix/index'
import { Route as DemoDesignSystemInteractiveIndexRouteImport } from './routes/demo/design-system/interactive/index'
import { Route as DemoDesignSystemFoundationsIndexRouteImport } from './routes/demo/design-system/foundations/index'
import { Route as Demo3dVisualizationIndexRouteImport } from './routes/demo/3d/visualization/index'
import { Route as Demo3dUxIndexRouteImport } from './routes/demo/3d/ux/index'
import { Route as Demo3dMemoryIndexRouteImport } from './routes/demo/3d/memory/index'
import { Route as Demo3dLiveIndexRouteImport } from './routes/demo/3d/live/index'
import { Route as Demo3dExamplesIndexRouteImport } from './routes/demo/3d/examples/index'
import { Route as Demo3dDebugIndexRouteImport } from './routes/demo/3d/debug/index'
import { Route as Demo3dConfigurationIndexRouteImport } from './routes/demo/3d/configuration/index'
import { Route as DemoDesignSystemThemingThemeUtilitiesRouteImport } from './routes/demo/design-system/theming/theme-utilities'
import { Route as DemoDesignSystemThemingTailwindPluginRouteImport } from './routes/demo/design-system/theming/tailwind-plugin'
import { Route as DemoDesignSystemThemingOpacityUtilitiesRouteImport } from './routes/demo/design-system/theming/opacity-utilities'
import { Route as DemoDesignSystemThemingExamplesRouteImport } from './routes/demo/design-system/theming/examples'
import { Route as DemoDesignSystemTestsComponentSizeRouteImport } from './routes/demo/design-system/tests/component-size'
import { Route as DemoDesignSystemSpecialtyDomainBadgeRouteImport } from './routes/demo/design-system/specialty/domain-badge'
import { Route as DemoDesignSystemRadixSelectRouteImport } from './routes/demo/design-system/radix/select'
import { Route as DemoDesignSystemRadixScrollAreaRouteImport } from './routes/demo/design-system/radix/scroll-area'
import { Route as DemoDesignSystemRadixRadixExamplesRouteImport } from './routes/demo/design-system/radix/radix-examples'
import { Route as DemoDesignSystemRadixPopoverRouteImport } from './routes/demo/design-system/radix/popover'
import { Route as DemoDesignSystemRadixHoverCardRouteImport } from './routes/demo/design-system/radix/hover-card'
import { Route as DemoDesignSystemRadixAccordionRouteImport } from './routes/demo/design-system/radix/accordion'
import { Route as DemoDesignSystemInteractiveToastRouteImport } from './routes/demo/design-system/interactive/toast'
import { Route as DemoDesignSystemInteractiveTabsRouteImport } from './routes/demo/design-system/interactive/tabs'
import { Route as DemoDesignSystemInteractiveSwitchRouteImport } from './routes/demo/design-system/interactive/switch'
import { Route as DemoDesignSystemInteractiveSliderRouteImport } from './routes/demo/design-system/interactive/slider'
import { Route as DemoDesignSystemInteractiveNavigationMenuRouteImport } from './routes/demo/design-system/interactive/navigation-menu'
import { Route as DemoDesignSystemInteractiveDropdownRouteImport } from './routes/demo/design-system/interactive/dropdown'
import { Route as DemoDesignSystemInteractiveCollapsibleRouteImport } from './routes/demo/design-system/interactive/collapsible'
import { Route as DemoDesignSystemFoundationsLabelsRouteImport } from './routes/demo/design-system/foundations/labels'
import { Route as DemoDesignSystemFoundationsCardsRouteImport } from './routes/demo/design-system/foundations/cards'
import { Route as DemoDesignSystemFoundationsButtonsRouteImport } from './routes/demo/design-system/foundations/buttons'
import { Route as Demo3dVisualizationTransactionHistoryRouteImport } from './routes/demo/3d/visualization/transaction-history'
import { Route as Demo3dVisualizationSchemaViewerRouteImport } from './routes/demo/3d/visualization/schema-viewer'
import { Route as Demo3dVisualizationDiffViewerRouteImport } from './routes/demo/3d/visualization/diff-viewer'
import { Route as Demo3dUxShowcaseRouteImport } from './routes/demo/3d/ux/showcase'
import { Route as Demo3dUxHeroRouteImport } from './routes/demo/3d/ux/hero'
import { Route as Demo3dUxBasicsRouteImport } from './routes/demo/3d/ux/basics'
import { Route as Demo3dMemoryOnBlurRouteImport } from './routes/demo/3d/memory/on-blur'
import { Route as Demo3dMemoryImmediateRouteImport } from './routes/demo/3d/memory/immediate'
import { Route as Demo3dMemoryDebouncedRouteImport } from './routes/demo/3d/memory/debounced'
import { Route as Demo3dLiveRealtimeRouteImport } from './routes/demo/3d/live/realtime'
import { Route as Demo3dLivePerformanceRouteImport } from './routes/demo/3d/live/performance'
import { Route as Demo3dLiveBabylonSceneRouteImport } from './routes/demo/3d/live/babylon-scene'
import { Route as Demo3dExamplesErrorHandlingRouteImport } from './routes/demo/3d/examples/error-handling'
import { Route as Demo3dExamplesBasicRouteImport } from './routes/demo/3d/examples/basic'
import { Route as Demo3dExamplesAdvancedRouteImport } from './routes/demo/3d/examples/advanced'
import { Route as Demo3dDebugTransactionDebuggerRouteImport } from './routes/demo/3d/debug/transaction-debugger'
import { Route as Demo3dDebugStateInspectorRouteImport } from './routes/demo/3d/debug/state-inspector'
import { Route as Demo3dDebugPerformanceProfilerRouteImport } from './routes/demo/3d/debug/performance-profiler'
import { Route as Demo3dConfigurationSchemaEditorRouteImport } from './routes/demo/3d/configuration/schema-editor'
import { Route as Demo3dConfigurationPresetsRouteImport } from './routes/demo/3d/configuration/presets'
import { Route as Demo3dConfigurationPlaygroundRouteImport } from './routes/demo/3d/configuration/playground'
import { Route as ImmersiveDemo3dUxRouteImport } from './routes/_immersive/demo/3d/ux'
import { Route as ImmersiveDemo3dUxRuneRouteImport } from './routes/_immersive/demo/3d/ux/rune'
import { Route as ImmersiveDemo3dUxGemRouteImport } from './routes/_immersive/demo/3d/ux/gem'
import { Route as ImmersiveDemo3dUxBobRouteImport } from './routes/_immersive/demo/3d/ux/bob'

const GemRoute = GemRouteImport.update({
  id: '/gem',
  path: '/gem',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const ImmersiveRoute = ImmersiveRouteImport.update({
  id: '/_immersive',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoIndexRoute = DemoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemoRoute,
} as any)
const DemoTestsRoute = DemoTestsRouteImport.update({
  id: '/tests',
  path: '/tests',
  getParentRoute: () => DemoRoute,
} as any)
const DemoDesignSystemRoute = DemoDesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => DemoRoute,
} as any)
const Demo3dRoute = Demo3dRouteImport.update({
  id: '/3d',
  path: '/3d',
  getParentRoute: () => DemoRoute,
} as any)
const DemoTestsIndexRoute = DemoTestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemoTestsRoute,
} as any)
const DemoDesignSystemIndexRoute = DemoDesignSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const Demo3dIndexRoute = Demo3dIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Demo3dRoute,
} as any)
const DemoTestsComponentSizeTestRoute =
  DemoTestsComponentSizeTestRouteImport.update({
    id: '/component-size-test',
    path: '/component-size-test',
    getParentRoute: () => DemoTestsRoute,
  } as any)
const DemoDesignSystemThemingRoute = DemoDesignSystemThemingRouteImport.update({
  id: '/theming',
  path: '/theming',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const DemoDesignSystemTestsRoute = DemoDesignSystemTestsRouteImport.update({
  id: '/tests',
  path: '/tests',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const DemoDesignSystemSpecialtyRoute =
  DemoDesignSystemSpecialtyRouteImport.update({
    id: '/specialty',
    path: '/specialty',
    getParentRoute: () => DemoDesignSystemRoute,
  } as any)
const DemoDesignSystemRadixRoute = DemoDesignSystemRadixRouteImport.update({
  id: '/radix',
  path: '/radix',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const DemoDesignSystemInteractiveRoute =
  DemoDesignSystemInteractiveRouteImport.update({
    id: '/interactive',
    path: '/interactive',
    getParentRoute: () => DemoDesignSystemRoute,
  } as any)
const DemoDesignSystemFoundationsRoute =
  DemoDesignSystemFoundationsRouteImport.update({
    id: '/foundations',
    path: '/foundations',
    getParentRoute: () => DemoDesignSystemRoute,
  } as any)
const Demo3dVisualizationRoute = Demo3dVisualizationRouteImport.update({
  id: '/visualization',
  path: '/visualization',
  getParentRoute: () => Demo3dRoute,
} as any)
const Demo3dUxRoute = Demo3dUxRouteImport.update({
  id: '/ux',
  path: '/ux',
  getParentRoute: () => Demo3dRoute,
} as any)
const Demo3dMemoryRoute = Demo3dMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => Demo3dRoute,
} as any)
const Demo3dLiveRoute = Demo3dLiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => Demo3dRoute,
} as any)
const Demo3dExamplesRoute = Demo3dExamplesRouteImport.update({
  id: '/examples',
  path: '/examples',
  getParentRoute: () => Demo3dRoute,
} as any)
const Demo3dDebugRoute = Demo3dDebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => Demo3dRoute,
} as any)
const Demo3dConfigurationRoute = Demo3dConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => Demo3dRoute,
} as any)
const DemoDesignSystemThemingIndexRoute =
  DemoDesignSystemThemingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemTestsIndexRoute =
  DemoDesignSystemTestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemTestsRoute,
  } as any)
const DemoDesignSystemSpecialtyIndexRoute =
  DemoDesignSystemSpecialtyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemSpecialtyRoute,
  } as any)
const DemoDesignSystemRadixIndexRoute =
  DemoDesignSystemRadixIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemInteractiveIndexRoute =
  DemoDesignSystemInteractiveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemFoundationsIndexRoute =
  DemoDesignSystemFoundationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const Demo3dVisualizationIndexRoute =
  Demo3dVisualizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Demo3dVisualizationRoute,
  } as any)
const Demo3dUxIndexRoute = Demo3dUxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Demo3dUxRoute,
} as any)
const Demo3dMemoryIndexRoute = Demo3dMemoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Demo3dMemoryRoute,
} as any)
const Demo3dLiveIndexRoute = Demo3dLiveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Demo3dLiveRoute,
} as any)
const Demo3dExamplesIndexRoute = Demo3dExamplesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Demo3dExamplesRoute,
} as any)
const Demo3dDebugIndexRoute = Demo3dDebugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Demo3dDebugRoute,
} as any)
const Demo3dConfigurationIndexRoute =
  Demo3dConfigurationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Demo3dConfigurationRoute,
  } as any)
const DemoDesignSystemThemingThemeUtilitiesRoute =
  DemoDesignSystemThemingThemeUtilitiesRouteImport.update({
    id: '/theme-utilities',
    path: '/theme-utilities',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemThemingTailwindPluginRoute =
  DemoDesignSystemThemingTailwindPluginRouteImport.update({
    id: '/tailwind-plugin',
    path: '/tailwind-plugin',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemThemingOpacityUtilitiesRoute =
  DemoDesignSystemThemingOpacityUtilitiesRouteImport.update({
    id: '/opacity-utilities',
    path: '/opacity-utilities',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemThemingExamplesRoute =
  DemoDesignSystemThemingExamplesRouteImport.update({
    id: '/examples',
    path: '/examples',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemTestsComponentSizeRoute =
  DemoDesignSystemTestsComponentSizeRouteImport.update({
    id: '/component-size',
    path: '/component-size',
    getParentRoute: () => DemoDesignSystemTestsRoute,
  } as any)
const DemoDesignSystemSpecialtyDomainBadgeRoute =
  DemoDesignSystemSpecialtyDomainBadgeRouteImport.update({
    id: '/domain-badge',
    path: '/domain-badge',
    getParentRoute: () => DemoDesignSystemSpecialtyRoute,
  } as any)
const DemoDesignSystemRadixSelectRoute =
  DemoDesignSystemRadixSelectRouteImport.update({
    id: '/select',
    path: '/select',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixScrollAreaRoute =
  DemoDesignSystemRadixScrollAreaRouteImport.update({
    id: '/scroll-area',
    path: '/scroll-area',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixRadixExamplesRoute =
  DemoDesignSystemRadixRadixExamplesRouteImport.update({
    id: '/radix-examples',
    path: '/radix-examples',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixPopoverRoute =
  DemoDesignSystemRadixPopoverRouteImport.update({
    id: '/popover',
    path: '/popover',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixHoverCardRoute =
  DemoDesignSystemRadixHoverCardRouteImport.update({
    id: '/hover-card',
    path: '/hover-card',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixAccordionRoute =
  DemoDesignSystemRadixAccordionRouteImport.update({
    id: '/accordion',
    path: '/accordion',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemInteractiveToastRoute =
  DemoDesignSystemInteractiveToastRouteImport.update({
    id: '/toast',
    path: '/toast',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveTabsRoute =
  DemoDesignSystemInteractiveTabsRouteImport.update({
    id: '/tabs',
    path: '/tabs',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveSwitchRoute =
  DemoDesignSystemInteractiveSwitchRouteImport.update({
    id: '/switch',
    path: '/switch',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveSliderRoute =
  DemoDesignSystemInteractiveSliderRouteImport.update({
    id: '/slider',
    path: '/slider',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveNavigationMenuRoute =
  DemoDesignSystemInteractiveNavigationMenuRouteImport.update({
    id: '/navigation-menu',
    path: '/navigation-menu',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveDropdownRoute =
  DemoDesignSystemInteractiveDropdownRouteImport.update({
    id: '/dropdown',
    path: '/dropdown',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveCollapsibleRoute =
  DemoDesignSystemInteractiveCollapsibleRouteImport.update({
    id: '/collapsible',
    path: '/collapsible',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemFoundationsLabelsRoute =
  DemoDesignSystemFoundationsLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const DemoDesignSystemFoundationsCardsRoute =
  DemoDesignSystemFoundationsCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const DemoDesignSystemFoundationsButtonsRoute =
  DemoDesignSystemFoundationsButtonsRouteImport.update({
    id: '/buttons',
    path: '/buttons',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const Demo3dVisualizationTransactionHistoryRoute =
  Demo3dVisualizationTransactionHistoryRouteImport.update({
    id: '/transaction-history',
    path: '/transaction-history',
    getParentRoute: () => Demo3dVisualizationRoute,
  } as any)
const Demo3dVisualizationSchemaViewerRoute =
  Demo3dVisualizationSchemaViewerRouteImport.update({
    id: '/schema-viewer',
    path: '/schema-viewer',
    getParentRoute: () => Demo3dVisualizationRoute,
  } as any)
const Demo3dVisualizationDiffViewerRoute =
  Demo3dVisualizationDiffViewerRouteImport.update({
    id: '/diff-viewer',
    path: '/diff-viewer',
    getParentRoute: () => Demo3dVisualizationRoute,
  } as any)
const Demo3dUxShowcaseRoute = Demo3dUxShowcaseRouteImport.update({
  id: '/showcase',
  path: '/showcase',
  getParentRoute: () => Demo3dUxRoute,
} as any)
const Demo3dUxHeroRoute = Demo3dUxHeroRouteImport.update({
  id: '/hero',
  path: '/hero',
  getParentRoute: () => Demo3dUxRoute,
} as any)
const Demo3dUxBasicsRoute = Demo3dUxBasicsRouteImport.update({
  id: '/basics',
  path: '/basics',
  getParentRoute: () => Demo3dUxRoute,
} as any)
const Demo3dMemoryOnBlurRoute = Demo3dMemoryOnBlurRouteImport.update({
  id: '/on-blur',
  path: '/on-blur',
  getParentRoute: () => Demo3dMemoryRoute,
} as any)
const Demo3dMemoryImmediateRoute = Demo3dMemoryImmediateRouteImport.update({
  id: '/immediate',
  path: '/immediate',
  getParentRoute: () => Demo3dMemoryRoute,
} as any)
const Demo3dMemoryDebouncedRoute = Demo3dMemoryDebouncedRouteImport.update({
  id: '/debounced',
  path: '/debounced',
  getParentRoute: () => Demo3dMemoryRoute,
} as any)
const Demo3dLiveRealtimeRoute = Demo3dLiveRealtimeRouteImport.update({
  id: '/realtime',
  path: '/realtime',
  getParentRoute: () => Demo3dLiveRoute,
} as any)
const Demo3dLivePerformanceRoute = Demo3dLivePerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => Demo3dLiveRoute,
} as any)
const Demo3dLiveBabylonSceneRoute = Demo3dLiveBabylonSceneRouteImport.update({
  id: '/babylon-scene',
  path: '/babylon-scene',
  getParentRoute: () => Demo3dLiveRoute,
} as any)
const Demo3dExamplesErrorHandlingRoute =
  Demo3dExamplesErrorHandlingRouteImport.update({
    id: '/error-handling',
    path: '/error-handling',
    getParentRoute: () => Demo3dExamplesRoute,
  } as any)
const Demo3dExamplesBasicRoute = Demo3dExamplesBasicRouteImport.update({
  id: '/basic',
  path: '/basic',
  getParentRoute: () => Demo3dExamplesRoute,
} as any)
const Demo3dExamplesAdvancedRoute = Demo3dExamplesAdvancedRouteImport.update({
  id: '/advanced',
  path: '/advanced',
  getParentRoute: () => Demo3dExamplesRoute,
} as any)
const Demo3dDebugTransactionDebuggerRoute =
  Demo3dDebugTransactionDebuggerRouteImport.update({
    id: '/transaction-debugger',
    path: '/transaction-debugger',
    getParentRoute: () => Demo3dDebugRoute,
  } as any)
const Demo3dDebugStateInspectorRoute =
  Demo3dDebugStateInspectorRouteImport.update({
    id: '/state-inspector',
    path: '/state-inspector',
    getParentRoute: () => Demo3dDebugRoute,
  } as any)
const Demo3dDebugPerformanceProfilerRoute =
  Demo3dDebugPerformanceProfilerRouteImport.update({
    id: '/performance-profiler',
    path: '/performance-profiler',
    getParentRoute: () => Demo3dDebugRoute,
  } as any)
const Demo3dConfigurationSchemaEditorRoute =
  Demo3dConfigurationSchemaEditorRouteImport.update({
    id: '/schema-editor',
    path: '/schema-editor',
    getParentRoute: () => Demo3dConfigurationRoute,
  } as any)
const Demo3dConfigurationPresetsRoute =
  Demo3dConfigurationPresetsRouteImport.update({
    id: '/presets',
    path: '/presets',
    getParentRoute: () => Demo3dConfigurationRoute,
  } as any)
const Demo3dConfigurationPlaygroundRoute =
  Demo3dConfigurationPlaygroundRouteImport.update({
    id: '/playground',
    path: '/playground',
    getParentRoute: () => Demo3dConfigurationRoute,
  } as any)
const ImmersiveDemo3dUxRoute = ImmersiveDemo3dUxRouteImport.update({
  id: '/demo/3d/ux',
  path: '/demo/3d/ux',
  getParentRoute: () => ImmersiveRoute,
} as any)
const ImmersiveDemo3dUxRuneRoute = ImmersiveDemo3dUxRuneRouteImport.update({
  id: '/rune',
  path: '/rune',
  getParentRoute: () => ImmersiveDemo3dUxRoute,
} as any)
const ImmersiveDemo3dUxGemRoute = ImmersiveDemo3dUxGemRouteImport.update({
  id: '/gem',
  path: '/gem',
  getParentRoute: () => ImmersiveDemo3dUxRoute,
} as any)
const ImmersiveDemo3dUxBobRoute = ImmersiveDemo3dUxBobRouteImport.update({
  id: '/bob',
  path: '/bob',
  getParentRoute: () => ImmersiveDemo3dUxRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/demo': typeof DemoRouteWithChildren
  '/gem': typeof GemRoute
  '/demo/3d': typeof Demo3dRouteWithChildren
  '/demo/design-system': typeof DemoDesignSystemRouteWithChildren
  '/demo/tests': typeof DemoTestsRouteWithChildren
  '/demo/': typeof DemoIndexRoute
  '/demo/3d/configuration': typeof Demo3dConfigurationRouteWithChildren
  '/demo/3d/debug': typeof Demo3dDebugRouteWithChildren
  '/demo/3d/examples': typeof Demo3dExamplesRouteWithChildren
  '/demo/3d/live': typeof Demo3dLiveRouteWithChildren
  '/demo/3d/memory': typeof Demo3dMemoryRouteWithChildren
  '/demo/3d/ux': typeof ImmersiveDemo3dUxRouteWithChildren
  '/demo/3d/visualization': typeof Demo3dVisualizationRouteWithChildren
  '/demo/design-system/foundations': typeof DemoDesignSystemFoundationsRouteWithChildren
  '/demo/design-system/interactive': typeof DemoDesignSystemInteractiveRouteWithChildren
  '/demo/design-system/radix': typeof DemoDesignSystemRadixRouteWithChildren
  '/demo/design-system/specialty': typeof DemoDesignSystemSpecialtyRouteWithChildren
  '/demo/design-system/tests': typeof DemoDesignSystemTestsRouteWithChildren
  '/demo/design-system/theming': typeof DemoDesignSystemThemingRouteWithChildren
  '/demo/tests/component-size-test': typeof DemoTestsComponentSizeTestRoute
  '/demo/3d/': typeof Demo3dIndexRoute
  '/demo/design-system/': typeof DemoDesignSystemIndexRoute
  '/demo/tests/': typeof DemoTestsIndexRoute
  '/demo/3d/configuration/playground': typeof Demo3dConfigurationPlaygroundRoute
  '/demo/3d/configuration/presets': typeof Demo3dConfigurationPresetsRoute
  '/demo/3d/configuration/schema-editor': typeof Demo3dConfigurationSchemaEditorRoute
  '/demo/3d/debug/performance-profiler': typeof Demo3dDebugPerformanceProfilerRoute
  '/demo/3d/debug/state-inspector': typeof Demo3dDebugStateInspectorRoute
  '/demo/3d/debug/transaction-debugger': typeof Demo3dDebugTransactionDebuggerRoute
  '/demo/3d/examples/advanced': typeof Demo3dExamplesAdvancedRoute
  '/demo/3d/examples/basic': typeof Demo3dExamplesBasicRoute
  '/demo/3d/examples/error-handling': typeof Demo3dExamplesErrorHandlingRoute
  '/demo/3d/live/babylon-scene': typeof Demo3dLiveBabylonSceneRoute
  '/demo/3d/live/performance': typeof Demo3dLivePerformanceRoute
  '/demo/3d/live/realtime': typeof Demo3dLiveRealtimeRoute
  '/demo/3d/memory/debounced': typeof Demo3dMemoryDebouncedRoute
  '/demo/3d/memory/immediate': typeof Demo3dMemoryImmediateRoute
  '/demo/3d/memory/on-blur': typeof Demo3dMemoryOnBlurRoute
  '/demo/3d/ux/basics': typeof Demo3dUxBasicsRoute
  '/demo/3d/ux/hero': typeof Demo3dUxHeroRoute
  '/demo/3d/ux/showcase': typeof Demo3dUxShowcaseRoute
  '/demo/3d/visualization/diff-viewer': typeof Demo3dVisualizationDiffViewerRoute
  '/demo/3d/visualization/schema-viewer': typeof Demo3dVisualizationSchemaViewerRoute
  '/demo/3d/visualization/transaction-history': typeof Demo3dVisualizationTransactionHistoryRoute
  '/demo/design-system/foundations/buttons': typeof DemoDesignSystemFoundationsButtonsRoute
  '/demo/design-system/foundations/cards': typeof DemoDesignSystemFoundationsCardsRoute
  '/demo/design-system/foundations/labels': typeof DemoDesignSystemFoundationsLabelsRoute
  '/demo/design-system/interactive/collapsible': typeof DemoDesignSystemInteractiveCollapsibleRoute
  '/demo/design-system/interactive/dropdown': typeof DemoDesignSystemInteractiveDropdownRoute
  '/demo/design-system/interactive/navigation-menu': typeof DemoDesignSystemInteractiveNavigationMenuRoute
  '/demo/design-system/interactive/slider': typeof DemoDesignSystemInteractiveSliderRoute
  '/demo/design-system/interactive/switch': typeof DemoDesignSystemInteractiveSwitchRoute
  '/demo/design-system/interactive/tabs': typeof DemoDesignSystemInteractiveTabsRoute
  '/demo/design-system/interactive/toast': typeof DemoDesignSystemInteractiveToastRoute
  '/demo/design-system/radix/accordion': typeof DemoDesignSystemRadixAccordionRoute
  '/demo/design-system/radix/hover-card': typeof DemoDesignSystemRadixHoverCardRoute
  '/demo/design-system/radix/popover': typeof DemoDesignSystemRadixPopoverRoute
  '/demo/design-system/radix/radix-examples': typeof DemoDesignSystemRadixRadixExamplesRoute
  '/demo/design-system/radix/scroll-area': typeof DemoDesignSystemRadixScrollAreaRoute
  '/demo/design-system/radix/select': typeof DemoDesignSystemRadixSelectRoute
  '/demo/design-system/specialty/domain-badge': typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  '/demo/design-system/tests/component-size': typeof DemoDesignSystemTestsComponentSizeRoute
  '/demo/design-system/theming/examples': typeof DemoDesignSystemThemingExamplesRoute
  '/demo/design-system/theming/opacity-utilities': typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  '/demo/design-system/theming/tailwind-plugin': typeof DemoDesignSystemThemingTailwindPluginRoute
  '/demo/design-system/theming/theme-utilities': typeof DemoDesignSystemThemingThemeUtilitiesRoute
  '/demo/3d/configuration/': typeof Demo3dConfigurationIndexRoute
  '/demo/3d/debug/': typeof Demo3dDebugIndexRoute
  '/demo/3d/examples/': typeof Demo3dExamplesIndexRoute
  '/demo/3d/live/': typeof Demo3dLiveIndexRoute
  '/demo/3d/memory/': typeof Demo3dMemoryIndexRoute
  '/demo/3d/ux/': typeof Demo3dUxIndexRoute
  '/demo/3d/visualization/': typeof Demo3dVisualizationIndexRoute
  '/demo/design-system/foundations/': typeof DemoDesignSystemFoundationsIndexRoute
  '/demo/design-system/interactive/': typeof DemoDesignSystemInteractiveIndexRoute
  '/demo/design-system/radix/': typeof DemoDesignSystemRadixIndexRoute
  '/demo/design-system/specialty/': typeof DemoDesignSystemSpecialtyIndexRoute
  '/demo/design-system/tests/': typeof DemoDesignSystemTestsIndexRoute
  '/demo/design-system/theming/': typeof DemoDesignSystemThemingIndexRoute
  '/demo/3d/ux/bob': typeof ImmersiveDemo3dUxBobRoute
  '/demo/3d/ux/gem': typeof ImmersiveDemo3dUxGemRoute
  '/demo/3d/ux/rune': typeof ImmersiveDemo3dUxRuneRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/gem': typeof GemRoute
  '/demo': typeof DemoIndexRoute
  '/demo/tests/component-size-test': typeof DemoTestsComponentSizeTestRoute
  '/demo/3d': typeof Demo3dIndexRoute
  '/demo/design-system': typeof DemoDesignSystemIndexRoute
  '/demo/tests': typeof DemoTestsIndexRoute
  '/demo/3d/ux': typeof Demo3dUxIndexRoute
  '/demo/3d/configuration/playground': typeof Demo3dConfigurationPlaygroundRoute
  '/demo/3d/configuration/presets': typeof Demo3dConfigurationPresetsRoute
  '/demo/3d/configuration/schema-editor': typeof Demo3dConfigurationSchemaEditorRoute
  '/demo/3d/debug/performance-profiler': typeof Demo3dDebugPerformanceProfilerRoute
  '/demo/3d/debug/state-inspector': typeof Demo3dDebugStateInspectorRoute
  '/demo/3d/debug/transaction-debugger': typeof Demo3dDebugTransactionDebuggerRoute
  '/demo/3d/examples/advanced': typeof Demo3dExamplesAdvancedRoute
  '/demo/3d/examples/basic': typeof Demo3dExamplesBasicRoute
  '/demo/3d/examples/error-handling': typeof Demo3dExamplesErrorHandlingRoute
  '/demo/3d/live/babylon-scene': typeof Demo3dLiveBabylonSceneRoute
  '/demo/3d/live/performance': typeof Demo3dLivePerformanceRoute
  '/demo/3d/live/realtime': typeof Demo3dLiveRealtimeRoute
  '/demo/3d/memory/debounced': typeof Demo3dMemoryDebouncedRoute
  '/demo/3d/memory/immediate': typeof Demo3dMemoryImmediateRoute
  '/demo/3d/memory/on-blur': typeof Demo3dMemoryOnBlurRoute
  '/demo/3d/ux/basics': typeof Demo3dUxBasicsRoute
  '/demo/3d/ux/hero': typeof Demo3dUxHeroRoute
  '/demo/3d/ux/showcase': typeof Demo3dUxShowcaseRoute
  '/demo/3d/visualization/diff-viewer': typeof Demo3dVisualizationDiffViewerRoute
  '/demo/3d/visualization/schema-viewer': typeof Demo3dVisualizationSchemaViewerRoute
  '/demo/3d/visualization/transaction-history': typeof Demo3dVisualizationTransactionHistoryRoute
  '/demo/design-system/foundations/buttons': typeof DemoDesignSystemFoundationsButtonsRoute
  '/demo/design-system/foundations/cards': typeof DemoDesignSystemFoundationsCardsRoute
  '/demo/design-system/foundations/labels': typeof DemoDesignSystemFoundationsLabelsRoute
  '/demo/design-system/interactive/collapsible': typeof DemoDesignSystemInteractiveCollapsibleRoute
  '/demo/design-system/interactive/dropdown': typeof DemoDesignSystemInteractiveDropdownRoute
  '/demo/design-system/interactive/navigation-menu': typeof DemoDesignSystemInteractiveNavigationMenuRoute
  '/demo/design-system/interactive/slider': typeof DemoDesignSystemInteractiveSliderRoute
  '/demo/design-system/interactive/switch': typeof DemoDesignSystemInteractiveSwitchRoute
  '/demo/design-system/interactive/tabs': typeof DemoDesignSystemInteractiveTabsRoute
  '/demo/design-system/interactive/toast': typeof DemoDesignSystemInteractiveToastRoute
  '/demo/design-system/radix/accordion': typeof DemoDesignSystemRadixAccordionRoute
  '/demo/design-system/radix/hover-card': typeof DemoDesignSystemRadixHoverCardRoute
  '/demo/design-system/radix/popover': typeof DemoDesignSystemRadixPopoverRoute
  '/demo/design-system/radix/radix-examples': typeof DemoDesignSystemRadixRadixExamplesRoute
  '/demo/design-system/radix/scroll-area': typeof DemoDesignSystemRadixScrollAreaRoute
  '/demo/design-system/radix/select': typeof DemoDesignSystemRadixSelectRoute
  '/demo/design-system/specialty/domain-badge': typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  '/demo/design-system/tests/component-size': typeof DemoDesignSystemTestsComponentSizeRoute
  '/demo/design-system/theming/examples': typeof DemoDesignSystemThemingExamplesRoute
  '/demo/design-system/theming/opacity-utilities': typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  '/demo/design-system/theming/tailwind-plugin': typeof DemoDesignSystemThemingTailwindPluginRoute
  '/demo/design-system/theming/theme-utilities': typeof DemoDesignSystemThemingThemeUtilitiesRoute
  '/demo/3d/configuration': typeof Demo3dConfigurationIndexRoute
  '/demo/3d/debug': typeof Demo3dDebugIndexRoute
  '/demo/3d/examples': typeof Demo3dExamplesIndexRoute
  '/demo/3d/live': typeof Demo3dLiveIndexRoute
  '/demo/3d/memory': typeof Demo3dMemoryIndexRoute
  '/demo/3d/visualization': typeof Demo3dVisualizationIndexRoute
  '/demo/design-system/foundations': typeof DemoDesignSystemFoundationsIndexRoute
  '/demo/design-system/interactive': typeof DemoDesignSystemInteractiveIndexRoute
  '/demo/design-system/radix': typeof DemoDesignSystemRadixIndexRoute
  '/demo/design-system/specialty': typeof DemoDesignSystemSpecialtyIndexRoute
  '/demo/design-system/tests': typeof DemoDesignSystemTestsIndexRoute
  '/demo/design-system/theming': typeof DemoDesignSystemThemingIndexRoute
  '/demo/3d/ux/bob': typeof ImmersiveDemo3dUxBobRoute
  '/demo/3d/ux/gem': typeof ImmersiveDemo3dUxGemRoute
  '/demo/3d/ux/rune': typeof ImmersiveDemo3dUxRuneRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_immersive': typeof ImmersiveRouteWithChildren
  '/demo': typeof DemoRouteWithChildren
  '/gem': typeof GemRoute
  '/demo/3d': typeof Demo3dRouteWithChildren
  '/demo/design-system': typeof DemoDesignSystemRouteWithChildren
  '/demo/tests': typeof DemoTestsRouteWithChildren
  '/demo/': typeof DemoIndexRoute
  '/demo/3d/configuration': typeof Demo3dConfigurationRouteWithChildren
  '/demo/3d/debug': typeof Demo3dDebugRouteWithChildren
  '/demo/3d/examples': typeof Demo3dExamplesRouteWithChildren
  '/demo/3d/live': typeof Demo3dLiveRouteWithChildren
  '/demo/3d/memory': typeof Demo3dMemoryRouteWithChildren
  '/demo/3d/ux': typeof Demo3dUxRouteWithChildren
  '/demo/3d/visualization': typeof Demo3dVisualizationRouteWithChildren
  '/demo/design-system/foundations': typeof DemoDesignSystemFoundationsRouteWithChildren
  '/demo/design-system/interactive': typeof DemoDesignSystemInteractiveRouteWithChildren
  '/demo/design-system/radix': typeof DemoDesignSystemRadixRouteWithChildren
  '/demo/design-system/specialty': typeof DemoDesignSystemSpecialtyRouteWithChildren
  '/demo/design-system/tests': typeof DemoDesignSystemTestsRouteWithChildren
  '/demo/design-system/theming': typeof DemoDesignSystemThemingRouteWithChildren
  '/demo/tests/component-size-test': typeof DemoTestsComponentSizeTestRoute
  '/demo/3d/': typeof Demo3dIndexRoute
  '/demo/design-system/': typeof DemoDesignSystemIndexRoute
  '/demo/tests/': typeof DemoTestsIndexRoute
  '/_immersive/demo/3d/ux': typeof ImmersiveDemo3dUxRouteWithChildren
  '/demo/3d/configuration/playground': typeof Demo3dConfigurationPlaygroundRoute
  '/demo/3d/configuration/presets': typeof Demo3dConfigurationPresetsRoute
  '/demo/3d/configuration/schema-editor': typeof Demo3dConfigurationSchemaEditorRoute
  '/demo/3d/debug/performance-profiler': typeof Demo3dDebugPerformanceProfilerRoute
  '/demo/3d/debug/state-inspector': typeof Demo3dDebugStateInspectorRoute
  '/demo/3d/debug/transaction-debugger': typeof Demo3dDebugTransactionDebuggerRoute
  '/demo/3d/examples/advanced': typeof Demo3dExamplesAdvancedRoute
  '/demo/3d/examples/basic': typeof Demo3dExamplesBasicRoute
  '/demo/3d/examples/error-handling': typeof Demo3dExamplesErrorHandlingRoute
  '/demo/3d/live/babylon-scene': typeof Demo3dLiveBabylonSceneRoute
  '/demo/3d/live/performance': typeof Demo3dLivePerformanceRoute
  '/demo/3d/live/realtime': typeof Demo3dLiveRealtimeRoute
  '/demo/3d/memory/debounced': typeof Demo3dMemoryDebouncedRoute
  '/demo/3d/memory/immediate': typeof Demo3dMemoryImmediateRoute
  '/demo/3d/memory/on-blur': typeof Demo3dMemoryOnBlurRoute
  '/demo/3d/ux/basics': typeof Demo3dUxBasicsRoute
  '/demo/3d/ux/hero': typeof Demo3dUxHeroRoute
  '/demo/3d/ux/showcase': typeof Demo3dUxShowcaseRoute
  '/demo/3d/visualization/diff-viewer': typeof Demo3dVisualizationDiffViewerRoute
  '/demo/3d/visualization/schema-viewer': typeof Demo3dVisualizationSchemaViewerRoute
  '/demo/3d/visualization/transaction-history': typeof Demo3dVisualizationTransactionHistoryRoute
  '/demo/design-system/foundations/buttons': typeof DemoDesignSystemFoundationsButtonsRoute
  '/demo/design-system/foundations/cards': typeof DemoDesignSystemFoundationsCardsRoute
  '/demo/design-system/foundations/labels': typeof DemoDesignSystemFoundationsLabelsRoute
  '/demo/design-system/interactive/collapsible': typeof DemoDesignSystemInteractiveCollapsibleRoute
  '/demo/design-system/interactive/dropdown': typeof DemoDesignSystemInteractiveDropdownRoute
  '/demo/design-system/interactive/navigation-menu': typeof DemoDesignSystemInteractiveNavigationMenuRoute
  '/demo/design-system/interactive/slider': typeof DemoDesignSystemInteractiveSliderRoute
  '/demo/design-system/interactive/switch': typeof DemoDesignSystemInteractiveSwitchRoute
  '/demo/design-system/interactive/tabs': typeof DemoDesignSystemInteractiveTabsRoute
  '/demo/design-system/interactive/toast': typeof DemoDesignSystemInteractiveToastRoute
  '/demo/design-system/radix/accordion': typeof DemoDesignSystemRadixAccordionRoute
  '/demo/design-system/radix/hover-card': typeof DemoDesignSystemRadixHoverCardRoute
  '/demo/design-system/radix/popover': typeof DemoDesignSystemRadixPopoverRoute
  '/demo/design-system/radix/radix-examples': typeof DemoDesignSystemRadixRadixExamplesRoute
  '/demo/design-system/radix/scroll-area': typeof DemoDesignSystemRadixScrollAreaRoute
  '/demo/design-system/radix/select': typeof DemoDesignSystemRadixSelectRoute
  '/demo/design-system/specialty/domain-badge': typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  '/demo/design-system/tests/component-size': typeof DemoDesignSystemTestsComponentSizeRoute
  '/demo/design-system/theming/examples': typeof DemoDesignSystemThemingExamplesRoute
  '/demo/design-system/theming/opacity-utilities': typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  '/demo/design-system/theming/tailwind-plugin': typeof DemoDesignSystemThemingTailwindPluginRoute
  '/demo/design-system/theming/theme-utilities': typeof DemoDesignSystemThemingThemeUtilitiesRoute
  '/demo/3d/configuration/': typeof Demo3dConfigurationIndexRoute
  '/demo/3d/debug/': typeof Demo3dDebugIndexRoute
  '/demo/3d/examples/': typeof Demo3dExamplesIndexRoute
  '/demo/3d/live/': typeof Demo3dLiveIndexRoute
  '/demo/3d/memory/': typeof Demo3dMemoryIndexRoute
  '/demo/3d/ux/': typeof Demo3dUxIndexRoute
  '/demo/3d/visualization/': typeof Demo3dVisualizationIndexRoute
  '/demo/design-system/foundations/': typeof DemoDesignSystemFoundationsIndexRoute
  '/demo/design-system/interactive/': typeof DemoDesignSystemInteractiveIndexRoute
  '/demo/design-system/radix/': typeof DemoDesignSystemRadixIndexRoute
  '/demo/design-system/specialty/': typeof DemoDesignSystemSpecialtyIndexRoute
  '/demo/design-system/tests/': typeof DemoDesignSystemTestsIndexRoute
  '/demo/design-system/theming/': typeof DemoDesignSystemThemingIndexRoute
  '/_immersive/demo/3d/ux/bob': typeof ImmersiveDemo3dUxBobRoute
  '/_immersive/demo/3d/ux/gem': typeof ImmersiveDemo3dUxGemRoute
  '/_immersive/demo/3d/ux/rune': typeof ImmersiveDemo3dUxRuneRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/demo'
    | '/gem'
    | '/demo/3d'
    | '/demo/design-system'
    | '/demo/tests'
    | '/demo/'
    | '/demo/3d/configuration'
    | '/demo/3d/debug'
    | '/demo/3d/examples'
    | '/demo/3d/live'
    | '/demo/3d/memory'
    | '/demo/3d/ux'
    | '/demo/3d/visualization'
    | '/demo/design-system/foundations'
    | '/demo/design-system/interactive'
    | '/demo/design-system/radix'
    | '/demo/design-system/specialty'
    | '/demo/design-system/tests'
    | '/demo/design-system/theming'
    | '/demo/tests/component-size-test'
    | '/demo/3d/'
    | '/demo/design-system/'
    | '/demo/tests/'
    | '/demo/3d/configuration/playground'
    | '/demo/3d/configuration/presets'
    | '/demo/3d/configuration/schema-editor'
    | '/demo/3d/debug/performance-profiler'
    | '/demo/3d/debug/state-inspector'
    | '/demo/3d/debug/transaction-debugger'
    | '/demo/3d/examples/advanced'
    | '/demo/3d/examples/basic'
    | '/demo/3d/examples/error-handling'
    | '/demo/3d/live/babylon-scene'
    | '/demo/3d/live/performance'
    | '/demo/3d/live/realtime'
    | '/demo/3d/memory/debounced'
    | '/demo/3d/memory/immediate'
    | '/demo/3d/memory/on-blur'
    | '/demo/3d/ux/basics'
    | '/demo/3d/ux/hero'
    | '/demo/3d/ux/showcase'
    | '/demo/3d/visualization/diff-viewer'
    | '/demo/3d/visualization/schema-viewer'
    | '/demo/3d/visualization/transaction-history'
    | '/demo/design-system/foundations/buttons'
    | '/demo/design-system/foundations/cards'
    | '/demo/design-system/foundations/labels'
    | '/demo/design-system/interactive/collapsible'
    | '/demo/design-system/interactive/dropdown'
    | '/demo/design-system/interactive/navigation-menu'
    | '/demo/design-system/interactive/slider'
    | '/demo/design-system/interactive/switch'
    | '/demo/design-system/interactive/tabs'
    | '/demo/design-system/interactive/toast'
    | '/demo/design-system/radix/accordion'
    | '/demo/design-system/radix/hover-card'
    | '/demo/design-system/radix/popover'
    | '/demo/design-system/radix/radix-examples'
    | '/demo/design-system/radix/scroll-area'
    | '/demo/design-system/radix/select'
    | '/demo/design-system/specialty/domain-badge'
    | '/demo/design-system/tests/component-size'
    | '/demo/design-system/theming/examples'
    | '/demo/design-system/theming/opacity-utilities'
    | '/demo/design-system/theming/tailwind-plugin'
    | '/demo/design-system/theming/theme-utilities'
    | '/demo/3d/configuration/'
    | '/demo/3d/debug/'
    | '/demo/3d/examples/'
    | '/demo/3d/live/'
    | '/demo/3d/memory/'
    | '/demo/3d/ux/'
    | '/demo/3d/visualization/'
    | '/demo/design-system/foundations/'
    | '/demo/design-system/interactive/'
    | '/demo/design-system/radix/'
    | '/demo/design-system/specialty/'
    | '/demo/design-system/tests/'
    | '/demo/design-system/theming/'
    | '/demo/3d/ux/bob'
    | '/demo/3d/ux/gem'
    | '/demo/3d/ux/rune'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/gem'
    | '/demo'
    | '/demo/tests/component-size-test'
    | '/demo/3d'
    | '/demo/design-system'
    | '/demo/tests'
    | '/demo/3d/ux'
    | '/demo/3d/configuration/playground'
    | '/demo/3d/configuration/presets'
    | '/demo/3d/configuration/schema-editor'
    | '/demo/3d/debug/performance-profiler'
    | '/demo/3d/debug/state-inspector'
    | '/demo/3d/debug/transaction-debugger'
    | '/demo/3d/examples/advanced'
    | '/demo/3d/examples/basic'
    | '/demo/3d/examples/error-handling'
    | '/demo/3d/live/babylon-scene'
    | '/demo/3d/live/performance'
    | '/demo/3d/live/realtime'
    | '/demo/3d/memory/debounced'
    | '/demo/3d/memory/immediate'
    | '/demo/3d/memory/on-blur'
    | '/demo/3d/ux/basics'
    | '/demo/3d/ux/hero'
    | '/demo/3d/ux/showcase'
    | '/demo/3d/visualization/diff-viewer'
    | '/demo/3d/visualization/schema-viewer'
    | '/demo/3d/visualization/transaction-history'
    | '/demo/design-system/foundations/buttons'
    | '/demo/design-system/foundations/cards'
    | '/demo/design-system/foundations/labels'
    | '/demo/design-system/interactive/collapsible'
    | '/demo/design-system/interactive/dropdown'
    | '/demo/design-system/interactive/navigation-menu'
    | '/demo/design-system/interactive/slider'
    | '/demo/design-system/interactive/switch'
    | '/demo/design-system/interactive/tabs'
    | '/demo/design-system/interactive/toast'
    | '/demo/design-system/radix/accordion'
    | '/demo/design-system/radix/hover-card'
    | '/demo/design-system/radix/popover'
    | '/demo/design-system/radix/radix-examples'
    | '/demo/design-system/radix/scroll-area'
    | '/demo/design-system/radix/select'
    | '/demo/design-system/specialty/domain-badge'
    | '/demo/design-system/tests/component-size'
    | '/demo/design-system/theming/examples'
    | '/demo/design-system/theming/opacity-utilities'
    | '/demo/design-system/theming/tailwind-plugin'
    | '/demo/design-system/theming/theme-utilities'
    | '/demo/3d/configuration'
    | '/demo/3d/debug'
    | '/demo/3d/examples'
    | '/demo/3d/live'
    | '/demo/3d/memory'
    | '/demo/3d/visualization'
    | '/demo/design-system/foundations'
    | '/demo/design-system/interactive'
    | '/demo/design-system/radix'
    | '/demo/design-system/specialty'
    | '/demo/design-system/tests'
    | '/demo/design-system/theming'
    | '/demo/3d/ux/bob'
    | '/demo/3d/ux/gem'
    | '/demo/3d/ux/rune'
  id:
    | '__root__'
    | '/'
    | '/_immersive'
    | '/demo'
    | '/gem'
    | '/demo/3d'
    | '/demo/design-system'
    | '/demo/tests'
    | '/demo/'
    | '/demo/3d/configuration'
    | '/demo/3d/debug'
    | '/demo/3d/examples'
    | '/demo/3d/live'
    | '/demo/3d/memory'
    | '/demo/3d/ux'
    | '/demo/3d/visualization'
    | '/demo/design-system/foundations'
    | '/demo/design-system/interactive'
    | '/demo/design-system/radix'
    | '/demo/design-system/specialty'
    | '/demo/design-system/tests'
    | '/demo/design-system/theming'
    | '/demo/tests/component-size-test'
    | '/demo/3d/'
    | '/demo/design-system/'
    | '/demo/tests/'
    | '/_immersive/demo/3d/ux'
    | '/demo/3d/configuration/playground'
    | '/demo/3d/configuration/presets'
    | '/demo/3d/configuration/schema-editor'
    | '/demo/3d/debug/performance-profiler'
    | '/demo/3d/debug/state-inspector'
    | '/demo/3d/debug/transaction-debugger'
    | '/demo/3d/examples/advanced'
    | '/demo/3d/examples/basic'
    | '/demo/3d/examples/error-handling'
    | '/demo/3d/live/babylon-scene'
    | '/demo/3d/live/performance'
    | '/demo/3d/live/realtime'
    | '/demo/3d/memory/debounced'
    | '/demo/3d/memory/immediate'
    | '/demo/3d/memory/on-blur'
    | '/demo/3d/ux/basics'
    | '/demo/3d/ux/hero'
    | '/demo/3d/ux/showcase'
    | '/demo/3d/visualization/diff-viewer'
    | '/demo/3d/visualization/schema-viewer'
    | '/demo/3d/visualization/transaction-history'
    | '/demo/design-system/foundations/buttons'
    | '/demo/design-system/foundations/cards'
    | '/demo/design-system/foundations/labels'
    | '/demo/design-system/interactive/collapsible'
    | '/demo/design-system/interactive/dropdown'
    | '/demo/design-system/interactive/navigation-menu'
    | '/demo/design-system/interactive/slider'
    | '/demo/design-system/interactive/switch'
    | '/demo/design-system/interactive/tabs'
    | '/demo/design-system/interactive/toast'
    | '/demo/design-system/radix/accordion'
    | '/demo/design-system/radix/hover-card'
    | '/demo/design-system/radix/popover'
    | '/demo/design-system/radix/radix-examples'
    | '/demo/design-system/radix/scroll-area'
    | '/demo/design-system/radix/select'
    | '/demo/design-system/specialty/domain-badge'
    | '/demo/design-system/tests/component-size'
    | '/demo/design-system/theming/examples'
    | '/demo/design-system/theming/opacity-utilities'
    | '/demo/design-system/theming/tailwind-plugin'
    | '/demo/design-system/theming/theme-utilities'
    | '/demo/3d/configuration/'
    | '/demo/3d/debug/'
    | '/demo/3d/examples/'
    | '/demo/3d/live/'
    | '/demo/3d/memory/'
    | '/demo/3d/ux/'
    | '/demo/3d/visualization/'
    | '/demo/design-system/foundations/'
    | '/demo/design-system/interactive/'
    | '/demo/design-system/radix/'
    | '/demo/design-system/specialty/'
    | '/demo/design-system/tests/'
    | '/demo/design-system/theming/'
    | '/_immersive/demo/3d/ux/bob'
    | '/_immersive/demo/3d/ux/gem'
    | '/_immersive/demo/3d/ux/rune'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ImmersiveRoute: typeof ImmersiveRouteWithChildren
  DemoRoute: typeof DemoRouteWithChildren
  GemRoute: typeof GemRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/gem': {
      id: '/gem'
      path: '/gem'
      fullPath: '/gem'
      preLoaderRoute: typeof GemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_immersive': {
      id: '/_immersive'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ImmersiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/': {
      id: '/demo/'
      path: '/'
      fullPath: '/demo/'
      preLoaderRoute: typeof DemoIndexRouteImport
      parentRoute: typeof DemoRoute
    }
    '/demo/tests': {
      id: '/demo/tests'
      path: '/tests'
      fullPath: '/demo/tests'
      preLoaderRoute: typeof DemoTestsRouteImport
      parentRoute: typeof DemoRoute
    }
    '/demo/design-system': {
      id: '/demo/design-system'
      path: '/design-system'
      fullPath: '/demo/design-system'
      preLoaderRoute: typeof DemoDesignSystemRouteImport
      parentRoute: typeof DemoRoute
    }
    '/demo/3d': {
      id: '/demo/3d'
      path: '/3d'
      fullPath: '/demo/3d'
      preLoaderRoute: typeof Demo3dRouteImport
      parentRoute: typeof DemoRoute
    }
    '/demo/tests/': {
      id: '/demo/tests/'
      path: '/'
      fullPath: '/demo/tests/'
      preLoaderRoute: typeof DemoTestsIndexRouteImport
      parentRoute: typeof DemoTestsRoute
    }
    '/demo/design-system/': {
      id: '/demo/design-system/'
      path: '/'
      fullPath: '/demo/design-system/'
      preLoaderRoute: typeof DemoDesignSystemIndexRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/3d/': {
      id: '/demo/3d/'
      path: '/'
      fullPath: '/demo/3d/'
      preLoaderRoute: typeof Demo3dIndexRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/tests/component-size-test': {
      id: '/demo/tests/component-size-test'
      path: '/component-size-test'
      fullPath: '/demo/tests/component-size-test'
      preLoaderRoute: typeof DemoTestsComponentSizeTestRouteImport
      parentRoute: typeof DemoTestsRoute
    }
    '/demo/design-system/theming': {
      id: '/demo/design-system/theming'
      path: '/theming'
      fullPath: '/demo/design-system/theming'
      preLoaderRoute: typeof DemoDesignSystemThemingRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/tests': {
      id: '/demo/design-system/tests'
      path: '/tests'
      fullPath: '/demo/design-system/tests'
      preLoaderRoute: typeof DemoDesignSystemTestsRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/specialty': {
      id: '/demo/design-system/specialty'
      path: '/specialty'
      fullPath: '/demo/design-system/specialty'
      preLoaderRoute: typeof DemoDesignSystemSpecialtyRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/radix': {
      id: '/demo/design-system/radix'
      path: '/radix'
      fullPath: '/demo/design-system/radix'
      preLoaderRoute: typeof DemoDesignSystemRadixRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/interactive': {
      id: '/demo/design-system/interactive'
      path: '/interactive'
      fullPath: '/demo/design-system/interactive'
      preLoaderRoute: typeof DemoDesignSystemInteractiveRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/foundations': {
      id: '/demo/design-system/foundations'
      path: '/foundations'
      fullPath: '/demo/design-system/foundations'
      preLoaderRoute: typeof DemoDesignSystemFoundationsRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/3d/visualization': {
      id: '/demo/3d/visualization'
      path: '/visualization'
      fullPath: '/demo/3d/visualization'
      preLoaderRoute: typeof Demo3dVisualizationRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/3d/ux': {
      id: '/demo/3d/ux'
      path: '/ux'
      fullPath: '/demo/3d/ux'
      preLoaderRoute: typeof Demo3dUxRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/3d/memory': {
      id: '/demo/3d/memory'
      path: '/memory'
      fullPath: '/demo/3d/memory'
      preLoaderRoute: typeof Demo3dMemoryRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/3d/live': {
      id: '/demo/3d/live'
      path: '/live'
      fullPath: '/demo/3d/live'
      preLoaderRoute: typeof Demo3dLiveRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/3d/examples': {
      id: '/demo/3d/examples'
      path: '/examples'
      fullPath: '/demo/3d/examples'
      preLoaderRoute: typeof Demo3dExamplesRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/3d/debug': {
      id: '/demo/3d/debug'
      path: '/debug'
      fullPath: '/demo/3d/debug'
      preLoaderRoute: typeof Demo3dDebugRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/3d/configuration': {
      id: '/demo/3d/configuration'
      path: '/configuration'
      fullPath: '/demo/3d/configuration'
      preLoaderRoute: typeof Demo3dConfigurationRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/design-system/theming/': {
      id: '/demo/design-system/theming/'
      path: '/'
      fullPath: '/demo/design-system/theming/'
      preLoaderRoute: typeof DemoDesignSystemThemingIndexRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/tests/': {
      id: '/demo/design-system/tests/'
      path: '/'
      fullPath: '/demo/design-system/tests/'
      preLoaderRoute: typeof DemoDesignSystemTestsIndexRouteImport
      parentRoute: typeof DemoDesignSystemTestsRoute
    }
    '/demo/design-system/specialty/': {
      id: '/demo/design-system/specialty/'
      path: '/'
      fullPath: '/demo/design-system/specialty/'
      preLoaderRoute: typeof DemoDesignSystemSpecialtyIndexRouteImport
      parentRoute: typeof DemoDesignSystemSpecialtyRoute
    }
    '/demo/design-system/radix/': {
      id: '/demo/design-system/radix/'
      path: '/'
      fullPath: '/demo/design-system/radix/'
      preLoaderRoute: typeof DemoDesignSystemRadixIndexRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/interactive/': {
      id: '/demo/design-system/interactive/'
      path: '/'
      fullPath: '/demo/design-system/interactive/'
      preLoaderRoute: typeof DemoDesignSystemInteractiveIndexRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/foundations/': {
      id: '/demo/design-system/foundations/'
      path: '/'
      fullPath: '/demo/design-system/foundations/'
      preLoaderRoute: typeof DemoDesignSystemFoundationsIndexRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/3d/visualization/': {
      id: '/demo/3d/visualization/'
      path: '/'
      fullPath: '/demo/3d/visualization/'
      preLoaderRoute: typeof Demo3dVisualizationIndexRouteImport
      parentRoute: typeof Demo3dVisualizationRoute
    }
    '/demo/3d/ux/': {
      id: '/demo/3d/ux/'
      path: '/'
      fullPath: '/demo/3d/ux/'
      preLoaderRoute: typeof Demo3dUxIndexRouteImport
      parentRoute: typeof Demo3dUxRoute
    }
    '/demo/3d/memory/': {
      id: '/demo/3d/memory/'
      path: '/'
      fullPath: '/demo/3d/memory/'
      preLoaderRoute: typeof Demo3dMemoryIndexRouteImport
      parentRoute: typeof Demo3dMemoryRoute
    }
    '/demo/3d/live/': {
      id: '/demo/3d/live/'
      path: '/'
      fullPath: '/demo/3d/live/'
      preLoaderRoute: typeof Demo3dLiveIndexRouteImport
      parentRoute: typeof Demo3dLiveRoute
    }
    '/demo/3d/examples/': {
      id: '/demo/3d/examples/'
      path: '/'
      fullPath: '/demo/3d/examples/'
      preLoaderRoute: typeof Demo3dExamplesIndexRouteImport
      parentRoute: typeof Demo3dExamplesRoute
    }
    '/demo/3d/debug/': {
      id: '/demo/3d/debug/'
      path: '/'
      fullPath: '/demo/3d/debug/'
      preLoaderRoute: typeof Demo3dDebugIndexRouteImport
      parentRoute: typeof Demo3dDebugRoute
    }
    '/demo/3d/configuration/': {
      id: '/demo/3d/configuration/'
      path: '/'
      fullPath: '/demo/3d/configuration/'
      preLoaderRoute: typeof Demo3dConfigurationIndexRouteImport
      parentRoute: typeof Demo3dConfigurationRoute
    }
    '/demo/design-system/theming/theme-utilities': {
      id: '/demo/design-system/theming/theme-utilities'
      path: '/theme-utilities'
      fullPath: '/demo/design-system/theming/theme-utilities'
      preLoaderRoute: typeof DemoDesignSystemThemingThemeUtilitiesRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/theming/tailwind-plugin': {
      id: '/demo/design-system/theming/tailwind-plugin'
      path: '/tailwind-plugin'
      fullPath: '/demo/design-system/theming/tailwind-plugin'
      preLoaderRoute: typeof DemoDesignSystemThemingTailwindPluginRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/theming/opacity-utilities': {
      id: '/demo/design-system/theming/opacity-utilities'
      path: '/opacity-utilities'
      fullPath: '/demo/design-system/theming/opacity-utilities'
      preLoaderRoute: typeof DemoDesignSystemThemingOpacityUtilitiesRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/theming/examples': {
      id: '/demo/design-system/theming/examples'
      path: '/examples'
      fullPath: '/demo/design-system/theming/examples'
      preLoaderRoute: typeof DemoDesignSystemThemingExamplesRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/tests/component-size': {
      id: '/demo/design-system/tests/component-size'
      path: '/component-size'
      fullPath: '/demo/design-system/tests/component-size'
      preLoaderRoute: typeof DemoDesignSystemTestsComponentSizeRouteImport
      parentRoute: typeof DemoDesignSystemTestsRoute
    }
    '/demo/design-system/specialty/domain-badge': {
      id: '/demo/design-system/specialty/domain-badge'
      path: '/domain-badge'
      fullPath: '/demo/design-system/specialty/domain-badge'
      preLoaderRoute: typeof DemoDesignSystemSpecialtyDomainBadgeRouteImport
      parentRoute: typeof DemoDesignSystemSpecialtyRoute
    }
    '/demo/design-system/radix/select': {
      id: '/demo/design-system/radix/select'
      path: '/select'
      fullPath: '/demo/design-system/radix/select'
      preLoaderRoute: typeof DemoDesignSystemRadixSelectRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/scroll-area': {
      id: '/demo/design-system/radix/scroll-area'
      path: '/scroll-area'
      fullPath: '/demo/design-system/radix/scroll-area'
      preLoaderRoute: typeof DemoDesignSystemRadixScrollAreaRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/radix-examples': {
      id: '/demo/design-system/radix/radix-examples'
      path: '/radix-examples'
      fullPath: '/demo/design-system/radix/radix-examples'
      preLoaderRoute: typeof DemoDesignSystemRadixRadixExamplesRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/popover': {
      id: '/demo/design-system/radix/popover'
      path: '/popover'
      fullPath: '/demo/design-system/radix/popover'
      preLoaderRoute: typeof DemoDesignSystemRadixPopoverRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/hover-card': {
      id: '/demo/design-system/radix/hover-card'
      path: '/hover-card'
      fullPath: '/demo/design-system/radix/hover-card'
      preLoaderRoute: typeof DemoDesignSystemRadixHoverCardRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/accordion': {
      id: '/demo/design-system/radix/accordion'
      path: '/accordion'
      fullPath: '/demo/design-system/radix/accordion'
      preLoaderRoute: typeof DemoDesignSystemRadixAccordionRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/interactive/toast': {
      id: '/demo/design-system/interactive/toast'
      path: '/toast'
      fullPath: '/demo/design-system/interactive/toast'
      preLoaderRoute: typeof DemoDesignSystemInteractiveToastRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/tabs': {
      id: '/demo/design-system/interactive/tabs'
      path: '/tabs'
      fullPath: '/demo/design-system/interactive/tabs'
      preLoaderRoute: typeof DemoDesignSystemInteractiveTabsRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/switch': {
      id: '/demo/design-system/interactive/switch'
      path: '/switch'
      fullPath: '/demo/design-system/interactive/switch'
      preLoaderRoute: typeof DemoDesignSystemInteractiveSwitchRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/slider': {
      id: '/demo/design-system/interactive/slider'
      path: '/slider'
      fullPath: '/demo/design-system/interactive/slider'
      preLoaderRoute: typeof DemoDesignSystemInteractiveSliderRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/navigation-menu': {
      id: '/demo/design-system/interactive/navigation-menu'
      path: '/navigation-menu'
      fullPath: '/demo/design-system/interactive/navigation-menu'
      preLoaderRoute: typeof DemoDesignSystemInteractiveNavigationMenuRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/dropdown': {
      id: '/demo/design-system/interactive/dropdown'
      path: '/dropdown'
      fullPath: '/demo/design-system/interactive/dropdown'
      preLoaderRoute: typeof DemoDesignSystemInteractiveDropdownRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/collapsible': {
      id: '/demo/design-system/interactive/collapsible'
      path: '/collapsible'
      fullPath: '/demo/design-system/interactive/collapsible'
      preLoaderRoute: typeof DemoDesignSystemInteractiveCollapsibleRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/foundations/labels': {
      id: '/demo/design-system/foundations/labels'
      path: '/labels'
      fullPath: '/demo/design-system/foundations/labels'
      preLoaderRoute: typeof DemoDesignSystemFoundationsLabelsRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/design-system/foundations/cards': {
      id: '/demo/design-system/foundations/cards'
      path: '/cards'
      fullPath: '/demo/design-system/foundations/cards'
      preLoaderRoute: typeof DemoDesignSystemFoundationsCardsRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/design-system/foundations/buttons': {
      id: '/demo/design-system/foundations/buttons'
      path: '/buttons'
      fullPath: '/demo/design-system/foundations/buttons'
      preLoaderRoute: typeof DemoDesignSystemFoundationsButtonsRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/3d/visualization/transaction-history': {
      id: '/demo/3d/visualization/transaction-history'
      path: '/transaction-history'
      fullPath: '/demo/3d/visualization/transaction-history'
      preLoaderRoute: typeof Demo3dVisualizationTransactionHistoryRouteImport
      parentRoute: typeof Demo3dVisualizationRoute
    }
    '/demo/3d/visualization/schema-viewer': {
      id: '/demo/3d/visualization/schema-viewer'
      path: '/schema-viewer'
      fullPath: '/demo/3d/visualization/schema-viewer'
      preLoaderRoute: typeof Demo3dVisualizationSchemaViewerRouteImport
      parentRoute: typeof Demo3dVisualizationRoute
    }
    '/demo/3d/visualization/diff-viewer': {
      id: '/demo/3d/visualization/diff-viewer'
      path: '/diff-viewer'
      fullPath: '/demo/3d/visualization/diff-viewer'
      preLoaderRoute: typeof Demo3dVisualizationDiffViewerRouteImport
      parentRoute: typeof Demo3dVisualizationRoute
    }
    '/demo/3d/ux/showcase': {
      id: '/demo/3d/ux/showcase'
      path: '/showcase'
      fullPath: '/demo/3d/ux/showcase'
      preLoaderRoute: typeof Demo3dUxShowcaseRouteImport
      parentRoute: typeof Demo3dUxRoute
    }
    '/demo/3d/ux/hero': {
      id: '/demo/3d/ux/hero'
      path: '/hero'
      fullPath: '/demo/3d/ux/hero'
      preLoaderRoute: typeof Demo3dUxHeroRouteImport
      parentRoute: typeof Demo3dUxRoute
    }
    '/demo/3d/ux/basics': {
      id: '/demo/3d/ux/basics'
      path: '/basics'
      fullPath: '/demo/3d/ux/basics'
      preLoaderRoute: typeof Demo3dUxBasicsRouteImport
      parentRoute: typeof Demo3dUxRoute
    }
    '/demo/3d/memory/on-blur': {
      id: '/demo/3d/memory/on-blur'
      path: '/on-blur'
      fullPath: '/demo/3d/memory/on-blur'
      preLoaderRoute: typeof Demo3dMemoryOnBlurRouteImport
      parentRoute: typeof Demo3dMemoryRoute
    }
    '/demo/3d/memory/immediate': {
      id: '/demo/3d/memory/immediate'
      path: '/immediate'
      fullPath: '/demo/3d/memory/immediate'
      preLoaderRoute: typeof Demo3dMemoryImmediateRouteImport
      parentRoute: typeof Demo3dMemoryRoute
    }
    '/demo/3d/memory/debounced': {
      id: '/demo/3d/memory/debounced'
      path: '/debounced'
      fullPath: '/demo/3d/memory/debounced'
      preLoaderRoute: typeof Demo3dMemoryDebouncedRouteImport
      parentRoute: typeof Demo3dMemoryRoute
    }
    '/demo/3d/live/realtime': {
      id: '/demo/3d/live/realtime'
      path: '/realtime'
      fullPath: '/demo/3d/live/realtime'
      preLoaderRoute: typeof Demo3dLiveRealtimeRouteImport
      parentRoute: typeof Demo3dLiveRoute
    }
    '/demo/3d/live/performance': {
      id: '/demo/3d/live/performance'
      path: '/performance'
      fullPath: '/demo/3d/live/performance'
      preLoaderRoute: typeof Demo3dLivePerformanceRouteImport
      parentRoute: typeof Demo3dLiveRoute
    }
    '/demo/3d/live/babylon-scene': {
      id: '/demo/3d/live/babylon-scene'
      path: '/babylon-scene'
      fullPath: '/demo/3d/live/babylon-scene'
      preLoaderRoute: typeof Demo3dLiveBabylonSceneRouteImport
      parentRoute: typeof Demo3dLiveRoute
    }
    '/demo/3d/examples/error-handling': {
      id: '/demo/3d/examples/error-handling'
      path: '/error-handling'
      fullPath: '/demo/3d/examples/error-handling'
      preLoaderRoute: typeof Demo3dExamplesErrorHandlingRouteImport
      parentRoute: typeof Demo3dExamplesRoute
    }
    '/demo/3d/examples/basic': {
      id: '/demo/3d/examples/basic'
      path: '/basic'
      fullPath: '/demo/3d/examples/basic'
      preLoaderRoute: typeof Demo3dExamplesBasicRouteImport
      parentRoute: typeof Demo3dExamplesRoute
    }
    '/demo/3d/examples/advanced': {
      id: '/demo/3d/examples/advanced'
      path: '/advanced'
      fullPath: '/demo/3d/examples/advanced'
      preLoaderRoute: typeof Demo3dExamplesAdvancedRouteImport
      parentRoute: typeof Demo3dExamplesRoute
    }
    '/demo/3d/debug/transaction-debugger': {
      id: '/demo/3d/debug/transaction-debugger'
      path: '/transaction-debugger'
      fullPath: '/demo/3d/debug/transaction-debugger'
      preLoaderRoute: typeof Demo3dDebugTransactionDebuggerRouteImport
      parentRoute: typeof Demo3dDebugRoute
    }
    '/demo/3d/debug/state-inspector': {
      id: '/demo/3d/debug/state-inspector'
      path: '/state-inspector'
      fullPath: '/demo/3d/debug/state-inspector'
      preLoaderRoute: typeof Demo3dDebugStateInspectorRouteImport
      parentRoute: typeof Demo3dDebugRoute
    }
    '/demo/3d/debug/performance-profiler': {
      id: '/demo/3d/debug/performance-profiler'
      path: '/performance-profiler'
      fullPath: '/demo/3d/debug/performance-profiler'
      preLoaderRoute: typeof Demo3dDebugPerformanceProfilerRouteImport
      parentRoute: typeof Demo3dDebugRoute
    }
    '/demo/3d/configuration/schema-editor': {
      id: '/demo/3d/configuration/schema-editor'
      path: '/schema-editor'
      fullPath: '/demo/3d/configuration/schema-editor'
      preLoaderRoute: typeof Demo3dConfigurationSchemaEditorRouteImport
      parentRoute: typeof Demo3dConfigurationRoute
    }
    '/demo/3d/configuration/presets': {
      id: '/demo/3d/configuration/presets'
      path: '/presets'
      fullPath: '/demo/3d/configuration/presets'
      preLoaderRoute: typeof Demo3dConfigurationPresetsRouteImport
      parentRoute: typeof Demo3dConfigurationRoute
    }
    '/demo/3d/configuration/playground': {
      id: '/demo/3d/configuration/playground'
      path: '/playground'
      fullPath: '/demo/3d/configuration/playground'
      preLoaderRoute: typeof Demo3dConfigurationPlaygroundRouteImport
      parentRoute: typeof Demo3dConfigurationRoute
    }
    '/_immersive/demo/3d/ux': {
      id: '/_immersive/demo/3d/ux'
      path: '/demo/3d/ux'
      fullPath: '/demo/3d/ux'
      preLoaderRoute: typeof ImmersiveDemo3dUxRouteImport
      parentRoute: typeof ImmersiveRoute
    }
    '/_immersive/demo/3d/ux/rune': {
      id: '/_immersive/demo/3d/ux/rune'
      path: '/rune'
      fullPath: '/demo/3d/ux/rune'
      preLoaderRoute: typeof ImmersiveDemo3dUxRuneRouteImport
      parentRoute: typeof ImmersiveDemo3dUxRoute
    }
    '/_immersive/demo/3d/ux/gem': {
      id: '/_immersive/demo/3d/ux/gem'
      path: '/gem'
      fullPath: '/demo/3d/ux/gem'
      preLoaderRoute: typeof ImmersiveDemo3dUxGemRouteImport
      parentRoute: typeof ImmersiveDemo3dUxRoute
    }
    '/_immersive/demo/3d/ux/bob': {
      id: '/_immersive/demo/3d/ux/bob'
      path: '/bob'
      fullPath: '/demo/3d/ux/bob'
      preLoaderRoute: typeof ImmersiveDemo3dUxBobRouteImport
      parentRoute: typeof ImmersiveDemo3dUxRoute
    }
  }
}

interface ImmersiveDemo3dUxRouteChildren {
  ImmersiveDemo3dUxBobRoute: typeof ImmersiveDemo3dUxBobRoute
  ImmersiveDemo3dUxGemRoute: typeof ImmersiveDemo3dUxGemRoute
  ImmersiveDemo3dUxRuneRoute: typeof ImmersiveDemo3dUxRuneRoute
}

const ImmersiveDemo3dUxRouteChildren: ImmersiveDemo3dUxRouteChildren = {
  ImmersiveDemo3dUxBobRoute: ImmersiveDemo3dUxBobRoute,
  ImmersiveDemo3dUxGemRoute: ImmersiveDemo3dUxGemRoute,
  ImmersiveDemo3dUxRuneRoute: ImmersiveDemo3dUxRuneRoute,
}

const ImmersiveDemo3dUxRouteWithChildren =
  ImmersiveDemo3dUxRoute._addFileChildren(ImmersiveDemo3dUxRouteChildren)

interface ImmersiveRouteChildren {
  ImmersiveDemo3dUxRoute: typeof ImmersiveDemo3dUxRouteWithChildren
}

const ImmersiveRouteChildren: ImmersiveRouteChildren = {
  ImmersiveDemo3dUxRoute: ImmersiveDemo3dUxRouteWithChildren,
}

const ImmersiveRouteWithChildren = ImmersiveRoute._addFileChildren(
  ImmersiveRouteChildren,
)

interface Demo3dConfigurationRouteChildren {
  Demo3dConfigurationPlaygroundRoute: typeof Demo3dConfigurationPlaygroundRoute
  Demo3dConfigurationPresetsRoute: typeof Demo3dConfigurationPresetsRoute
  Demo3dConfigurationSchemaEditorRoute: typeof Demo3dConfigurationSchemaEditorRoute
  Demo3dConfigurationIndexRoute: typeof Demo3dConfigurationIndexRoute
}

const Demo3dConfigurationRouteChildren: Demo3dConfigurationRouteChildren = {
  Demo3dConfigurationPlaygroundRoute: Demo3dConfigurationPlaygroundRoute,
  Demo3dConfigurationPresetsRoute: Demo3dConfigurationPresetsRoute,
  Demo3dConfigurationSchemaEditorRoute: Demo3dConfigurationSchemaEditorRoute,
  Demo3dConfigurationIndexRoute: Demo3dConfigurationIndexRoute,
}

const Demo3dConfigurationRouteWithChildren =
  Demo3dConfigurationRoute._addFileChildren(Demo3dConfigurationRouteChildren)

interface Demo3dDebugRouteChildren {
  Demo3dDebugPerformanceProfilerRoute: typeof Demo3dDebugPerformanceProfilerRoute
  Demo3dDebugStateInspectorRoute: typeof Demo3dDebugStateInspectorRoute
  Demo3dDebugTransactionDebuggerRoute: typeof Demo3dDebugTransactionDebuggerRoute
  Demo3dDebugIndexRoute: typeof Demo3dDebugIndexRoute
}

const Demo3dDebugRouteChildren: Demo3dDebugRouteChildren = {
  Demo3dDebugPerformanceProfilerRoute: Demo3dDebugPerformanceProfilerRoute,
  Demo3dDebugStateInspectorRoute: Demo3dDebugStateInspectorRoute,
  Demo3dDebugTransactionDebuggerRoute: Demo3dDebugTransactionDebuggerRoute,
  Demo3dDebugIndexRoute: Demo3dDebugIndexRoute,
}

const Demo3dDebugRouteWithChildren = Demo3dDebugRoute._addFileChildren(
  Demo3dDebugRouteChildren,
)

interface Demo3dExamplesRouteChildren {
  Demo3dExamplesAdvancedRoute: typeof Demo3dExamplesAdvancedRoute
  Demo3dExamplesBasicRoute: typeof Demo3dExamplesBasicRoute
  Demo3dExamplesErrorHandlingRoute: typeof Demo3dExamplesErrorHandlingRoute
  Demo3dExamplesIndexRoute: typeof Demo3dExamplesIndexRoute
}

const Demo3dExamplesRouteChildren: Demo3dExamplesRouteChildren = {
  Demo3dExamplesAdvancedRoute: Demo3dExamplesAdvancedRoute,
  Demo3dExamplesBasicRoute: Demo3dExamplesBasicRoute,
  Demo3dExamplesErrorHandlingRoute: Demo3dExamplesErrorHandlingRoute,
  Demo3dExamplesIndexRoute: Demo3dExamplesIndexRoute,
}

const Demo3dExamplesRouteWithChildren = Demo3dExamplesRoute._addFileChildren(
  Demo3dExamplesRouteChildren,
)

interface Demo3dLiveRouteChildren {
  Demo3dLiveBabylonSceneRoute: typeof Demo3dLiveBabylonSceneRoute
  Demo3dLivePerformanceRoute: typeof Demo3dLivePerformanceRoute
  Demo3dLiveRealtimeRoute: typeof Demo3dLiveRealtimeRoute
  Demo3dLiveIndexRoute: typeof Demo3dLiveIndexRoute
}

const Demo3dLiveRouteChildren: Demo3dLiveRouteChildren = {
  Demo3dLiveBabylonSceneRoute: Demo3dLiveBabylonSceneRoute,
  Demo3dLivePerformanceRoute: Demo3dLivePerformanceRoute,
  Demo3dLiveRealtimeRoute: Demo3dLiveRealtimeRoute,
  Demo3dLiveIndexRoute: Demo3dLiveIndexRoute,
}

const Demo3dLiveRouteWithChildren = Demo3dLiveRoute._addFileChildren(
  Demo3dLiveRouteChildren,
)

interface Demo3dMemoryRouteChildren {
  Demo3dMemoryDebouncedRoute: typeof Demo3dMemoryDebouncedRoute
  Demo3dMemoryImmediateRoute: typeof Demo3dMemoryImmediateRoute
  Demo3dMemoryOnBlurRoute: typeof Demo3dMemoryOnBlurRoute
  Demo3dMemoryIndexRoute: typeof Demo3dMemoryIndexRoute
}

const Demo3dMemoryRouteChildren: Demo3dMemoryRouteChildren = {
  Demo3dMemoryDebouncedRoute: Demo3dMemoryDebouncedRoute,
  Demo3dMemoryImmediateRoute: Demo3dMemoryImmediateRoute,
  Demo3dMemoryOnBlurRoute: Demo3dMemoryOnBlurRoute,
  Demo3dMemoryIndexRoute: Demo3dMemoryIndexRoute,
}

const Demo3dMemoryRouteWithChildren = Demo3dMemoryRoute._addFileChildren(
  Demo3dMemoryRouteChildren,
)

interface Demo3dUxRouteChildren {
  Demo3dUxBasicsRoute: typeof Demo3dUxBasicsRoute
  Demo3dUxHeroRoute: typeof Demo3dUxHeroRoute
  Demo3dUxShowcaseRoute: typeof Demo3dUxShowcaseRoute
  Demo3dUxIndexRoute: typeof Demo3dUxIndexRoute
}

const Demo3dUxRouteChildren: Demo3dUxRouteChildren = {
  Demo3dUxBasicsRoute: Demo3dUxBasicsRoute,
  Demo3dUxHeroRoute: Demo3dUxHeroRoute,
  Demo3dUxShowcaseRoute: Demo3dUxShowcaseRoute,
  Demo3dUxIndexRoute: Demo3dUxIndexRoute,
}

const Demo3dUxRouteWithChildren = Demo3dUxRoute._addFileChildren(
  Demo3dUxRouteChildren,
)

interface Demo3dVisualizationRouteChildren {
  Demo3dVisualizationDiffViewerRoute: typeof Demo3dVisualizationDiffViewerRoute
  Demo3dVisualizationSchemaViewerRoute: typeof Demo3dVisualizationSchemaViewerRoute
  Demo3dVisualizationTransactionHistoryRoute: typeof Demo3dVisualizationTransactionHistoryRoute
  Demo3dVisualizationIndexRoute: typeof Demo3dVisualizationIndexRoute
}

const Demo3dVisualizationRouteChildren: Demo3dVisualizationRouteChildren = {
  Demo3dVisualizationDiffViewerRoute: Demo3dVisualizationDiffViewerRoute,
  Demo3dVisualizationSchemaViewerRoute: Demo3dVisualizationSchemaViewerRoute,
  Demo3dVisualizationTransactionHistoryRoute:
    Demo3dVisualizationTransactionHistoryRoute,
  Demo3dVisualizationIndexRoute: Demo3dVisualizationIndexRoute,
}

const Demo3dVisualizationRouteWithChildren =
  Demo3dVisualizationRoute._addFileChildren(Demo3dVisualizationRouteChildren)

interface Demo3dRouteChildren {
  Demo3dConfigurationRoute: typeof Demo3dConfigurationRouteWithChildren
  Demo3dDebugRoute: typeof Demo3dDebugRouteWithChildren
  Demo3dExamplesRoute: typeof Demo3dExamplesRouteWithChildren
  Demo3dLiveRoute: typeof Demo3dLiveRouteWithChildren
  Demo3dMemoryRoute: typeof Demo3dMemoryRouteWithChildren
  Demo3dUxRoute: typeof Demo3dUxRouteWithChildren
  Demo3dVisualizationRoute: typeof Demo3dVisualizationRouteWithChildren
  Demo3dIndexRoute: typeof Demo3dIndexRoute
}

const Demo3dRouteChildren: Demo3dRouteChildren = {
  Demo3dConfigurationRoute: Demo3dConfigurationRouteWithChildren,
  Demo3dDebugRoute: Demo3dDebugRouteWithChildren,
  Demo3dExamplesRoute: Demo3dExamplesRouteWithChildren,
  Demo3dLiveRoute: Demo3dLiveRouteWithChildren,
  Demo3dMemoryRoute: Demo3dMemoryRouteWithChildren,
  Demo3dUxRoute: Demo3dUxRouteWithChildren,
  Demo3dVisualizationRoute: Demo3dVisualizationRouteWithChildren,
  Demo3dIndexRoute: Demo3dIndexRoute,
}

const Demo3dRouteWithChildren =
  Demo3dRoute._addFileChildren(Demo3dRouteChildren)

interface DemoDesignSystemFoundationsRouteChildren {
  DemoDesignSystemFoundationsButtonsRoute: typeof DemoDesignSystemFoundationsButtonsRoute
  DemoDesignSystemFoundationsCardsRoute: typeof DemoDesignSystemFoundationsCardsRoute
  DemoDesignSystemFoundationsLabelsRoute: typeof DemoDesignSystemFoundationsLabelsRoute
  DemoDesignSystemFoundationsIndexRoute: typeof DemoDesignSystemFoundationsIndexRoute
}

const DemoDesignSystemFoundationsRouteChildren: DemoDesignSystemFoundationsRouteChildren =
  {
    DemoDesignSystemFoundationsButtonsRoute:
      DemoDesignSystemFoundationsButtonsRoute,
    DemoDesignSystemFoundationsCardsRoute:
      DemoDesignSystemFoundationsCardsRoute,
    DemoDesignSystemFoundationsLabelsRoute:
      DemoDesignSystemFoundationsLabelsRoute,
    DemoDesignSystemFoundationsIndexRoute:
      DemoDesignSystemFoundationsIndexRoute,
  }

const DemoDesignSystemFoundationsRouteWithChildren =
  DemoDesignSystemFoundationsRoute._addFileChildren(
    DemoDesignSystemFoundationsRouteChildren,
  )

interface DemoDesignSystemInteractiveRouteChildren {
  DemoDesignSystemInteractiveCollapsibleRoute: typeof DemoDesignSystemInteractiveCollapsibleRoute
  DemoDesignSystemInteractiveDropdownRoute: typeof DemoDesignSystemInteractiveDropdownRoute
  DemoDesignSystemInteractiveNavigationMenuRoute: typeof DemoDesignSystemInteractiveNavigationMenuRoute
  DemoDesignSystemInteractiveSliderRoute: typeof DemoDesignSystemInteractiveSliderRoute
  DemoDesignSystemInteractiveSwitchRoute: typeof DemoDesignSystemInteractiveSwitchRoute
  DemoDesignSystemInteractiveTabsRoute: typeof DemoDesignSystemInteractiveTabsRoute
  DemoDesignSystemInteractiveToastRoute: typeof DemoDesignSystemInteractiveToastRoute
  DemoDesignSystemInteractiveIndexRoute: typeof DemoDesignSystemInteractiveIndexRoute
}

const DemoDesignSystemInteractiveRouteChildren: DemoDesignSystemInteractiveRouteChildren =
  {
    DemoDesignSystemInteractiveCollapsibleRoute:
      DemoDesignSystemInteractiveCollapsibleRoute,
    DemoDesignSystemInteractiveDropdownRoute:
      DemoDesignSystemInteractiveDropdownRoute,
    DemoDesignSystemInteractiveNavigationMenuRoute:
      DemoDesignSystemInteractiveNavigationMenuRoute,
    DemoDesignSystemInteractiveSliderRoute:
      DemoDesignSystemInteractiveSliderRoute,
    DemoDesignSystemInteractiveSwitchRoute:
      DemoDesignSystemInteractiveSwitchRoute,
    DemoDesignSystemInteractiveTabsRoute: DemoDesignSystemInteractiveTabsRoute,
    DemoDesignSystemInteractiveToastRoute:
      DemoDesignSystemInteractiveToastRoute,
    DemoDesignSystemInteractiveIndexRoute:
      DemoDesignSystemInteractiveIndexRoute,
  }

const DemoDesignSystemInteractiveRouteWithChildren =
  DemoDesignSystemInteractiveRoute._addFileChildren(
    DemoDesignSystemInteractiveRouteChildren,
  )

interface DemoDesignSystemRadixRouteChildren {
  DemoDesignSystemRadixAccordionRoute: typeof DemoDesignSystemRadixAccordionRoute
  DemoDesignSystemRadixHoverCardRoute: typeof DemoDesignSystemRadixHoverCardRoute
  DemoDesignSystemRadixPopoverRoute: typeof DemoDesignSystemRadixPopoverRoute
  DemoDesignSystemRadixRadixExamplesRoute: typeof DemoDesignSystemRadixRadixExamplesRoute
  DemoDesignSystemRadixScrollAreaRoute: typeof DemoDesignSystemRadixScrollAreaRoute
  DemoDesignSystemRadixSelectRoute: typeof DemoDesignSystemRadixSelectRoute
  DemoDesignSystemRadixIndexRoute: typeof DemoDesignSystemRadixIndexRoute
}

const DemoDesignSystemRadixRouteChildren: DemoDesignSystemRadixRouteChildren = {
  DemoDesignSystemRadixAccordionRoute: DemoDesignSystemRadixAccordionRoute,
  DemoDesignSystemRadixHoverCardRoute: DemoDesignSystemRadixHoverCardRoute,
  DemoDesignSystemRadixPopoverRoute: DemoDesignSystemRadixPopoverRoute,
  DemoDesignSystemRadixRadixExamplesRoute:
    DemoDesignSystemRadixRadixExamplesRoute,
  DemoDesignSystemRadixScrollAreaRoute: DemoDesignSystemRadixScrollAreaRoute,
  DemoDesignSystemRadixSelectRoute: DemoDesignSystemRadixSelectRoute,
  DemoDesignSystemRadixIndexRoute: DemoDesignSystemRadixIndexRoute,
}

const DemoDesignSystemRadixRouteWithChildren =
  DemoDesignSystemRadixRoute._addFileChildren(
    DemoDesignSystemRadixRouteChildren,
  )

interface DemoDesignSystemSpecialtyRouteChildren {
  DemoDesignSystemSpecialtyDomainBadgeRoute: typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  DemoDesignSystemSpecialtyIndexRoute: typeof DemoDesignSystemSpecialtyIndexRoute
}

const DemoDesignSystemSpecialtyRouteChildren: DemoDesignSystemSpecialtyRouteChildren =
  {
    DemoDesignSystemSpecialtyDomainBadgeRoute:
      DemoDesignSystemSpecialtyDomainBadgeRoute,
    DemoDesignSystemSpecialtyIndexRoute: DemoDesignSystemSpecialtyIndexRoute,
  }

const DemoDesignSystemSpecialtyRouteWithChildren =
  DemoDesignSystemSpecialtyRoute._addFileChildren(
    DemoDesignSystemSpecialtyRouteChildren,
  )

interface DemoDesignSystemTestsRouteChildren {
  DemoDesignSystemTestsComponentSizeRoute: typeof DemoDesignSystemTestsComponentSizeRoute
  DemoDesignSystemTestsIndexRoute: typeof DemoDesignSystemTestsIndexRoute
}

const DemoDesignSystemTestsRouteChildren: DemoDesignSystemTestsRouteChildren = {
  DemoDesignSystemTestsComponentSizeRoute:
    DemoDesignSystemTestsComponentSizeRoute,
  DemoDesignSystemTestsIndexRoute: DemoDesignSystemTestsIndexRoute,
}

const DemoDesignSystemTestsRouteWithChildren =
  DemoDesignSystemTestsRoute._addFileChildren(
    DemoDesignSystemTestsRouteChildren,
  )

interface DemoDesignSystemThemingRouteChildren {
  DemoDesignSystemThemingExamplesRoute: typeof DemoDesignSystemThemingExamplesRoute
  DemoDesignSystemThemingOpacityUtilitiesRoute: typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  DemoDesignSystemThemingTailwindPluginRoute: typeof DemoDesignSystemThemingTailwindPluginRoute
  DemoDesignSystemThemingThemeUtilitiesRoute: typeof DemoDesignSystemThemingThemeUtilitiesRoute
  DemoDesignSystemThemingIndexRoute: typeof DemoDesignSystemThemingIndexRoute
}

const DemoDesignSystemThemingRouteChildren: DemoDesignSystemThemingRouteChildren =
  {
    DemoDesignSystemThemingExamplesRoute: DemoDesignSystemThemingExamplesRoute,
    DemoDesignSystemThemingOpacityUtilitiesRoute:
      DemoDesignSystemThemingOpacityUtilitiesRoute,
    DemoDesignSystemThemingTailwindPluginRoute:
      DemoDesignSystemThemingTailwindPluginRoute,
    DemoDesignSystemThemingThemeUtilitiesRoute:
      DemoDesignSystemThemingThemeUtilitiesRoute,
    DemoDesignSystemThemingIndexRoute: DemoDesignSystemThemingIndexRoute,
  }

const DemoDesignSystemThemingRouteWithChildren =
  DemoDesignSystemThemingRoute._addFileChildren(
    DemoDesignSystemThemingRouteChildren,
  )

interface DemoDesignSystemRouteChildren {
  DemoDesignSystemFoundationsRoute: typeof DemoDesignSystemFoundationsRouteWithChildren
  DemoDesignSystemInteractiveRoute: typeof DemoDesignSystemInteractiveRouteWithChildren
  DemoDesignSystemRadixRoute: typeof DemoDesignSystemRadixRouteWithChildren
  DemoDesignSystemSpecialtyRoute: typeof DemoDesignSystemSpecialtyRouteWithChildren
  DemoDesignSystemTestsRoute: typeof DemoDesignSystemTestsRouteWithChildren
  DemoDesignSystemThemingRoute: typeof DemoDesignSystemThemingRouteWithChildren
  DemoDesignSystemIndexRoute: typeof DemoDesignSystemIndexRoute
}

const DemoDesignSystemRouteChildren: DemoDesignSystemRouteChildren = {
  DemoDesignSystemFoundationsRoute:
    DemoDesignSystemFoundationsRouteWithChildren,
  DemoDesignSystemInteractiveRoute:
    DemoDesignSystemInteractiveRouteWithChildren,
  DemoDesignSystemRadixRoute: DemoDesignSystemRadixRouteWithChildren,
  DemoDesignSystemSpecialtyRoute: DemoDesignSystemSpecialtyRouteWithChildren,
  DemoDesignSystemTestsRoute: DemoDesignSystemTestsRouteWithChildren,
  DemoDesignSystemThemingRoute: DemoDesignSystemThemingRouteWithChildren,
  DemoDesignSystemIndexRoute: DemoDesignSystemIndexRoute,
}

const DemoDesignSystemRouteWithChildren =
  DemoDesignSystemRoute._addFileChildren(DemoDesignSystemRouteChildren)

interface DemoTestsRouteChildren {
  DemoTestsComponentSizeTestRoute: typeof DemoTestsComponentSizeTestRoute
  DemoTestsIndexRoute: typeof DemoTestsIndexRoute
}

const DemoTestsRouteChildren: DemoTestsRouteChildren = {
  DemoTestsComponentSizeTestRoute: DemoTestsComponentSizeTestRoute,
  DemoTestsIndexRoute: DemoTestsIndexRoute,
}

const DemoTestsRouteWithChildren = DemoTestsRoute._addFileChildren(
  DemoTestsRouteChildren,
)

interface DemoRouteChildren {
  Demo3dRoute: typeof Demo3dRouteWithChildren
  DemoDesignSystemRoute: typeof DemoDesignSystemRouteWithChildren
  DemoTestsRoute: typeof DemoTestsRouteWithChildren
  DemoIndexRoute: typeof DemoIndexRoute
}

const DemoRouteChildren: DemoRouteChildren = {
  Demo3dRoute: Demo3dRouteWithChildren,
  DemoDesignSystemRoute: DemoDesignSystemRouteWithChildren,
  DemoTestsRoute: DemoTestsRouteWithChildren,
  DemoIndexRoute: DemoIndexRoute,
}

const DemoRouteWithChildren = DemoRoute._addFileChildren(DemoRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ImmersiveRoute: ImmersiveRouteWithChildren,
  DemoRoute: DemoRouteWithChildren,
  GemRoute: GemRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
